import { Button, Stack, Text } from '@mantine/core';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { removeAllDockedDialogs, removeAllFileUploadTask } from '../../../persisted/global/globalActions';
import type { UnauthenticatedAppOIDCProps } from '../../application/UnauthenticatedAppOIDC';
import { onLoginAction } from './onLoginAction';

let silentLoginTried = false;

export const OpenIdLoginPage = ({ login, silentLogin }: UnauthenticatedAppOIDCProps) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(removeAllFileUploadTask());
        dispatch(removeAllDockedDialogs());
    }, [dispatch]);

    useEffect(() => {
        if (!silentLoginTried) {
            silentLoginTried = true;
            silentLogin((user) => onLoginAction(user?.profile?.name));
        }
    }, []);

    return (
        <Stack h={'100%'} justify={'center'} align={'center'}>
            <Text>You are not logged in!</Text>
            <Button onClick={login} variant="filled">
                Login
            </Button>
        </Stack>
    );
};
